export default (state = { products: [], showcase: {} }, action) => {
  switch (action.type) {
    case 'FETCH_PRODUCT_SUGGESTIONS':
      return { ...state }
    case 'FETCH_PRODUCT_SUGGESTIONS_SUCCESS':
      return { ...state, ...action.payload.data }
    case 'FETCH_PRODUCT_SUGGESTIONS_FAIL':
      return { ...state, error: action.error }
    case 'FETCH_PRODUCT_CARD_AVAILABILITY':
      return { ...state }
    case 'FETCH_PRODUCT_CARD_AVAILABILITY_SUCCESS':
      const availability = action.payload.data[0]

      const { products } = state

      const {
        meta: {
          previousAction: { sku }
        }
      } = action

      const index = products.findIndex(p => p.sku === sku)

      if (products[index]) {
        products[index].availability = {
          ...availability
        }
      }

      return { ...state, products }
    case 'FETCH_PRODUCT_CARD_AVAILABILITY_FAIL':
      return { ...state, error_availability: action.error }
    default:
      return { ...state }
  }
}

export const Products = productSuggestion => {
  const { products, showcase } = productSuggestion

  const suggestion = {
    products: products || [],
    title: 'Troque seus pontos por produtos dos principais e-commerces.',
    titleOnlyCash: 'Compre produtos dos principais e-commerces.',
    titleMobile: 'Produtos',
    showcase: showcase
  }

  return suggestion
}



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductSuggestion/reducer.js